import { ControlType, Property, PropertyType } from "../../../base/types";

import { AvatarText } from "./AvatarText";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";

export const AvatarTextComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const label: string | undefined = properties[Property.Label];
    const tooltip: string | undefined = properties[Property.Tooltip];
    const size: number | undefined = properties[Property.Size];
    const random: boolean | undefined = properties[Property.Random];

    return (
        <AvatarText
            className={className}
            title={tooltip}
            label={label || ''}
            size={size}
            random={random || true} />
    )
}

Registry.addControl({
    id: "3d462d72-9908-4ce0-800c-ebc2f3746e96",
    name: "Avatar Text",
    type: ControlType.AvatarText,
    properties: [
        { id: Property.Label, name: 'Label', type: PropertyType.String },
        { id: Property.Size, name: 'Max. Size', type: PropertyType.Number },
        { id: Property.Random, name: 'Random Background', type: PropertyType.Boolean },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: AvatarTextComponent
})

